import { instance as axios } from '../axiosInstance';
import { statusHandler } from '../../utils/loginHelper';

const headers = (token) => ({ Authorization: `Bearer ${token}` });

export const listWhatsappChats = (token, pagination, tipo) => {
  const params = {
    page: pagination.currentPage,
    perPage: pagination.resultsPerPage,
    filter: pagination.filter || undefined,
    tipo: tipo || undefined,
  };

  return axios.get('/api/administrador/whatsapp/conversations', {
    headers: headers(token),
    validateStatus: statusHandler,
    params,
  });
};

export const listWhatsappMessages = (token, uuid, { sinceId = 0, page = 1, perPage = 100 } = {}) =>
  axios.get(`/api/administrador/whatsapp/conversations/${uuid}/messages`, {
    headers: headers(token),
    validateStatus: statusHandler,
    params: {
      since_id: sinceId || undefined,
      page: sinceId ? undefined : page,
      perPage,
    },
  });

export const takeoverWhatsappChat = (token, uuid) =>
  axios.post(
    `/api/administrador/whatsapp/conversations/${uuid}/takeover`,
    {},
    { headers: headers(token), validateStatus: statusHandler },
  );

export const releaseLuciaWhatsappChat = (token, uuid) =>
  axios.post(
    `/api/administrador/whatsapp/conversations/${uuid}/release-lucia`,
    {},
    { headers: headers(token), validateStatus: statusHandler },
  );

export const sendWhatsappHumanMessage = (token, uuid, text) =>
  axios.post(
    `/api/administrador/whatsapp/conversations/${uuid}/human-messages`,
    { text },
    { headers: headers(token), validateStatus: statusHandler },
  );

export const fetchWhatsappMessageMedia = (token, uuid, messageId) =>
  axios.get(`/api/administrador/whatsapp/conversations/${uuid}/messages/${messageId}/media`, {
    headers: headers(token),
    responseType: 'blob',
    validateStatus: () => true,
  });
